import { useCallback, useEffect, useState } from "react";

import {
  getActions,
  getAuthMe,
  getMyRaffleEntries,
  getBonusPromoChannel,
  getBonusPromoReviewLinks,
  getStoredAuthToken,
  getUsersMeReferral,
  postBonusPromo2gisReview,
  postBonusPromoBirthday,
  postBonusPromoChannelVerify,
  postBonusPromoPhone,
  postBonusPromoProfile,
  postBonusPromoYandexReview,
  postJoinRaffleAction,
} from "../api/api";
import { Button } from "../components/Button";
import { useAuth } from "../context/AuthContext";
import { useAuthUser } from "../hooks/useTelegram";
import { PromotionsActionsList } from "./promotions/PromotionsActionsList";
import { PromotionsBirthPromoCard } from "./promotions/PromotionsBirthPromoCard";
import { PromotionsChannelPromoCard } from "./promotions/PromotionsChannelPromoCard";
import { PromotionsIntroCard } from "./promotions/PromotionsIntroCard";
import { PromotionsPhonePromoCard } from "./promotions/PromotionsPhonePromoCard";
import { PromotionsProfilePromoCard } from "./promotions/PromotionsProfilePromoCard";
import { PromotionsReferralCard } from "./promotions/PromotionsReferralCard";
import { PromotionsReviewPromoCard } from "./promotions/PromotionsReviewPromoCard";
import { PromotionsReviewsIntroCard } from "./promotions/PromotionsReviewsIntroCard";
import { PROMO_REVIEW_MAP } from "./promotions/constants";
import { openReviewOutboundUrl, promoSuccessMessage } from "./promotions/utils";

export function Promotions({ onBack, onOpenPrivacyPolicy }) {
  const authUser = useAuthUser();
  const { setAuth } = useAuth();
  const [items, setItems] = useState([]);
  const [joinedRaffleIds, setJoinedRaffleIds] = useState([]);
  const [joiningRaffleId, setJoiningRaffleId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [patronymic, setPatronymic] = useState("");
  const [nickname, setNickname] = useState("");
  const [submittingProfile, setSubmittingProfile] = useState(false);
  const [errProfile, setErrProfile] = useState("");
  const [okProfile, setOkProfile] = useState("");

  const [birthDate, setBirthDate] = useState("");
  const [submittingBirth, setSubmittingBirth] = useState(false);
  const [errBirth, setErrBirth] = useState("");
  const [okBirth, setOkBirth] = useState("");

  const [phone, setPhone] = useState("");
  const [submittingPhone, setSubmittingPhone] = useState(false);
  const [errPhone, setErrPhone] = useState("");
  const [okPhone, setOkPhone] = useState("");

  const [promoChannel, setPromoChannel] = useState({ configured: false, channel_url: null });
  const [promoChannelLoading, setPromoChannelLoading] = useState(true);
  const [submittingChannel, setSubmittingChannel] = useState(false);
  const [errChannel, setErrChannel] = useState("");
  const [okChannel, setOkChannel] = useState("");

  const [reviewLinks, setReviewLinks] = useState({ yandex_url: "", gis_url: "" });
  const [reviewLinksLoading, setReviewLinksLoading] = useState(true);
  const [submittingYandexReview, setSubmittingYandexReview] = useState(false);
  const [errYandexReview, setErrYandexReview] = useState("");
  const [okYandexReview, setOkYandexReview] = useState("");
  const [submitting2gisReview, setSubmitting2gisReview] = useState(false);
  const [err2gisReview, setErr2gisReview] = useState("");
  const [ok2gisReview, setOk2gisReview] = useState("");

  const [referralLink, setReferralLink] = useState("");
  const [referralLoading, setReferralLoading] = useState(true);
  const [referralErr, setReferralErr] = useState("");
  const [referralCopied, setReferralCopied] = useState(false);

  const syncProfile = useCallback(() => {
    getAuthMe()
      .then((u) => {
        if (u?.id) setAuth(u, getStoredAuthToken());
      })
      .catch(() => {});
  }, [setAuth]);

  useEffect(() => {
    syncProfile();
  }, [syncProfile]);

  useEffect(() => {
    let mounted = true;
    getBonusPromoChannel()
      .then((data) => {
        if (!mounted) return;
        setPromoChannel({
          configured: Boolean(data?.configured),
          channel_url: (data?.channel_url || "").trim() || null,
        });
      })
      .catch(() => {
        if (!mounted) return;
        setPromoChannel({ configured: false, channel_url: null });
      })
      .finally(() => {
        if (mounted) setPromoChannelLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    let mounted = true;
    getMyRaffleEntries()
      .then((ids) => {
        if (!mounted) return;
        setJoinedRaffleIds(Array.isArray(ids) ? ids.map((x) => Number(x)) : []);
      })
      .catch(() => {
        if (!mounted) return;
        setJoinedRaffleIds([]);
      });
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    let mounted = true;
    getBonusPromoReviewLinks()
      .then((data) => {
        if (!mounted) return;
        setReviewLinks({
          yandex_url: (data?.yandex_url || "").trim(),
          gis_url: (data?.gis_url || "").trim(),
        });
      })
      .catch(() => {
        if (!mounted) return;
        setReviewLinks({ yandex_url: "", gis_url: "" });
      })
      .finally(() => {
        if (mounted) setReviewLinksLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    let mounted = true;
    getUsersMeReferral()
      .then((data) => {
        if (!mounted) return;
        setReferralLink((data?.link || "").trim());
        setReferralErr("");
      })
      .catch((err) => {
        if (!mounted) return;
        setReferralErr(err?.message || "Не удалось загрузить реферальную ссылку");
        setReferralLink("");
      })
      .finally(() => {
        if (mounted) setReferralLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    let mounted = true;
    getActions()
      .then((data) => {
        if (!mounted) return;
        setItems(data);
      })
      .catch((err) => {
        if (!mounted) return;
        setError(err?.message || "Не удалось загрузить акции");
      })
      .finally(() => {
        if (!mounted) return;
        setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  const doneProfile = Boolean(authUser?.promo_profile_completed_at);
  const doneBirth = Boolean(authUser?.promo_birthday_completed_at);
  const donePhone = Boolean(authUser?.promo_phone_completed_at);
  const doneChannel = Boolean(authUser?.promo_channel_completed_at);
  const doneTriple = Boolean(authUser?.promo_triple_bonus_completed_at);
  const doneYandexReview = Boolean(authUser?.promo_yandex_review_completed_at);
  const done2gisReview = Boolean(authUser?.promo_2gis_review_completed_at);

  const onPromoProfileSubmit = async (e) => {
    e.preventDefault();
    setErrProfile("");
    setOkProfile("");
    setSubmittingProfile(true);
    try {
      const res = await postBonusPromoProfile({
        profile_last_name: lastName.trim(),
        profile_first_name: firstName.trim(),
        profile_patronymic: patronymic.trim(),
        profile_nickname: nickname.trim() || null,
      });
      if (res?.user) {
        setAuth(res.user, getStoredAuthToken());
        setOkProfile(promoSuccessMessage(res));
      }
    } catch (err) {
      setErrProfile(err?.message || "Не удалось отправить");
    } finally {
      setSubmittingProfile(false);
    }
  };

  const onPromoBirthSubmit = async (e) => {
    e.preventDefault();
    setErrBirth("");
    setOkBirth("");
    setSubmittingBirth(true);
    try {
      const res = await postBonusPromoBirthday({
        birth_date: birthDate,
      });
      if (res?.user) {
        setAuth(res.user, getStoredAuthToken());
        setOkBirth(promoSuccessMessage(res));
      }
    } catch (err) {
      setErrBirth(err?.message || "Не удалось отправить");
    } finally {
      setSubmittingBirth(false);
    }
  };

  const onPromoPhoneSubmit = async (e) => {
    e.preventDefault();
    setErrPhone("");
    setOkPhone("");
    setSubmittingPhone(true);
    try {
      const res = await postBonusPromoPhone({
        phone: phone.trim(),
      });
      if (res?.user) {
        setAuth(res.user, getStoredAuthToken());
        setOkPhone(promoSuccessMessage(res));
      }
    } catch (err) {
      setErrPhone(err?.message || "Не удалось отправить");
    } finally {
      setSubmittingPhone(false);
    }
  };

  const onYandexReviewClick = async () => {
    if (!reviewLinks.yandex_url) return;
    setErrYandexReview("");
    setOkYandexReview("");
    openReviewOutboundUrl(reviewLinks.yandex_url);
    setSubmittingYandexReview(true);
    try {
      const res = await postBonusPromoYandexReview();
      if (res?.user) {
        setAuth(res.user, getStoredAuthToken());
        setOkYandexReview(promoSuccessMessage(res));
      }
    } catch (err) {
      setErrYandexReview(err?.message || "Не удалось зачесть акцию");
    } finally {
      setSubmittingYandexReview(false);
    }
  };

  const on2gisReviewClick = async () => {
    if (!reviewLinks.gis_url) return;
    setErr2gisReview("");
    setOk2gisReview("");
    openReviewOutboundUrl(reviewLinks.gis_url);
    setSubmitting2gisReview(true);
    try {
      const res = await postBonusPromo2gisReview();
      if (res?.user) {
        setAuth(res.user, getStoredAuthToken());
        setOk2gisReview(promoSuccessMessage(res));
      }
    } catch (err) {
      setErr2gisReview(err?.message || "Не удалось зачесть акцию");
    } finally {
      setSubmitting2gisReview(false);
    }
  };

  const onPromoChannelVerify = async () => {
    setErrChannel("");
    setOkChannel("");
    setSubmittingChannel(true);
    try {
      const res = await postBonusPromoChannelVerify();
      if (res?.user) {
        setAuth(res.user, getStoredAuthToken());
        setOkChannel(promoSuccessMessage(res));
      }
    } catch (err) {
      setErrChannel(err?.message || "Не удалось проверить подписку");
    } finally {
      setSubmittingChannel(false);
    }
  };

  const onCopyReferral = async () => {
    if (!referralLink) return;
    try {
      await navigator.clipboard.writeText(referralLink);
      setReferralCopied(true);
      window.setTimeout(() => setReferralCopied(false), 2500);
    } catch {
      setReferralErr("Не удалось скопировать ссылку");
    }
  };

  const onJoinRaffle = async (actionId) => {
    setError("");
    setJoiningRaffleId(actionId);
    try {
      await postJoinRaffleAction(actionId);
      setJoinedRaffleIds((prev) => (prev.includes(actionId) ? prev : [...prev, actionId]));
    } catch (err) {
      setError(err?.message || "Не удалось зарегистрироваться в розыгрыше");
    } finally {
      setJoiningRaffleId(null);
    }
  };

  return (
    <section className="client">
      <header className="sectionHeader">
        <h2>Акции и розыгрыши</h2>
        <p>Спецпредложения, конкурсы и розыгрыши призов.</p>
      </header>

      <div className="eventsToolbar">
        <Button onClick={onBack}>Назад</Button>
      </div>

      <PromotionsIntroCard doneTriple={doneTriple} />

      <div className="promotionsPinnedStack">
        <PromotionsReferralCard
          loading={referralLoading}
          err={referralErr}
          link={referralLink}
          copied={referralCopied}
          onCopy={onCopyReferral}
        />

        {!doneProfile ? (
          <PromotionsProfilePromoCard
            lastName={lastName}
            setLastName={setLastName}
            firstName={firstName}
            setFirstName={setFirstName}
            patronymic={patronymic}
            setPatronymic={setPatronymic}
            nickname={nickname}
            setNickname={setNickname}
            err={errProfile}
            ok={okProfile}
            submitting={submittingProfile}
            onSubmit={onPromoProfileSubmit}
            onOpenPrivacyPolicy={onOpenPrivacyPolicy}
          />
        ) : null}

        {!doneBirth ? (
          <PromotionsBirthPromoCard
            birthDate={birthDate}
            setBirthDate={setBirthDate}
            err={errBirth}
            ok={okBirth}
            submitting={submittingBirth}
            onSubmit={onPromoBirthSubmit}
            onOpenPrivacyPolicy={onOpenPrivacyPolicy}
          />
        ) : null}

        {!donePhone ? (
          <PromotionsPhonePromoCard
            phone={phone}
            setPhone={setPhone}
            err={errPhone}
            ok={okPhone}
            submitting={submittingPhone}
            onSubmit={onPromoPhoneSubmit}
            onOpenPrivacyPolicy={onOpenPrivacyPolicy}
          />
        ) : null}

        {!promoChannelLoading &&
        promoChannel.configured &&
        promoChannel.channel_url &&
        donePhone &&
        !doneChannel ? (
          <PromotionsChannelPromoCard
            channelUrl={promoChannel.channel_url}
            err={errChannel}
            ok={okChannel}
            submitting={submittingChannel}
            onVerify={onPromoChannelVerify}
          />
        ) : null}
      </div>

      <PromotionsReviewsIntroCard />

      <div className="promotionsPinnedStack">
        {!reviewLinksLoading && reviewLinks.yandex_url && !doneYandexReview ? (
          <PromotionsReviewPromoCard
            title={`Отзыв в Яндекс.Картах — ${PROMO_REVIEW_MAP} бонусов`}
            subtitle="Откроется страница отзывов «Стихия». Оставь текстовый отзыв, бонус начислим через 24 часа."
            err={errYandexReview}
            ok={okYandexReview}
            submitting={submittingYandexReview}
            onClick={onYandexReviewClick}
          />
        ) : null}

        {!reviewLinksLoading && reviewLinks.gis_url && !done2gisReview ? (
          <PromotionsReviewPromoCard
            title={`Отзыв в 2ГИС — ${PROMO_REVIEW_MAP} бонусов`}
            subtitle="Откроется вкладка отзывов. Оставь текстовый отзыв, бонус начислим через 24 часа."
            err={err2gisReview}
            ok={ok2gisReview}
            submitting={submitting2gisReview}
            onClick={on2gisReviewClick}
          />
        ) : null}
      </div>

      <PromotionsActionsList
        loading={loading}
        error={error}
        items={items}
        joinedRaffleIds={joinedRaffleIds}
        joiningRaffleId={joiningRaffleId}
        onJoinRaffle={onJoinRaffle}
      />
    </section>
  );
}
